import Toggle from './Toggle';

const ToggleBar = ({ toggles, selectedToggles, onChange }) => {

    const handleToggleChange = (toggleValue, isChecked) => {
        const updatedState = {};

        // If a toggle is checked, make sure it's the only one active
        if (isChecked) {
            toggles.forEach(toggle => {
                updatedState[toggle.value] = toggle.value === toggleValue;
            });
        } else {
            updatedState[toggleValue] = false;
        }

        if (onChange) {
            onChange(updatedState);  // Notify parent about the changes
        }
    };

    return (
        <div className='toggle-bar-container d-flex flex-column align-items-stretch'>
            <div className='toggle-bar-label'>Filter</div>
            <div className='px-4 flex-fill'>
                <div className='d-flex flex-row justify-content-between'>
                    {toggles.map((toggle, index) => (
                        <div className='toggle-bar-item' key={index}>
                            <Toggle
                                toggle={{
                                    ...toggle,
                                    active: selectedToggles[toggle.value] || false
                                }}
                                onChange={handleToggleChange}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ToggleBar;
